module.exports = __webpack_public_path__ + "img/thumbnail_FormosanBlackBear_m_normal.333f4603.png";